import BaseRegulation from '../base_regulation';
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import { DkStructuredLogging } from './logging/dk_structured_logging';
import LastLoginComponentController
  from '../../../../components/regulation_components/base/last_login/last_login_component_controller';
import LastLoginCompositeController
  from '../../../../components/regulation_components/base/last_login/last_login_composite_controller';
import SessionTimerController from '../../../../components/session_timer/session_timer_controller';
import DKResponsibleGamingIconsController
  from '../../../../components/regulation_components/denmark/responsible_gaming_icons/dk_responsible_gaming_icons_controller';
import {Check} from "@sparkware/app-utils";

export default class DkRegulation extends BaseRegulation {
  static CLASS = 'DkRegulation';

  _structuredLogger = null;
  _selfTestLink = "";
  _selfExclusionLink = "";


  init(params) {
    super.init(params);

    this._structuredLogger = DkStructuredLogging.create({
      serviceFactory: this.serviceFactory,
    });
    this._selfTestLink = params.selfTestLink;
    this._selfExclusionLink = params.selfExclusionLink;
  }

    sessionTimerVisible() {
        return true;
    }
  realityCheckEnabled() {
    return true;
  }

  sessionTimerEnabled() {
    return true;
  }

  showResponsibleIcons() {
    return true;
  }

  showAgeResponsibleGameInDetailedHistory() {
    return true;
  }

  showAgeResponsibleIconInGame() {
    return true;
  }

  getLastLoginComponent(params) {
      let lastLoginComponent = LastLoginComponentController.create(params);
      let sessionTimerComponent = SessionTimerController.create();
      return LastLoginCompositeController.create({lastLoginComponent: lastLoginComponent, sessionTimerComponent: sessionTimerComponent});
  }


    getResponsibleGamingIconsComponent(params){
        return DKResponsibleGamingIconsController.create(params);
    }

  showTempAccountMessage(closeFunc) {
    TempAccountMessageRegulationHelper.create({
      serviceFactory: this.serviceFactory,
    }).showTempAccountMessage({
      closeFunc: closeFunc,
      messageKey: 'dk_temp_account_message',
      titleKey: 'temp_account_title',
      btnNameKey: 'temp_account_upload_btn',
    });
  }

  _handleRealityCheckMessage(sessionTimer) {
    const isGameRunning = this.serviceFactory.gameService().isGameRunning();
    if (isGameRunning) {
      if (!this._realityCheckShouldBeDisplayedInGame()) {
        return;
      }
    }

    this.serviceFactory.userService().getRealityCheckData().then(data => {

      this.serviceFactory.gameService().stopCurrentGameAutoplay();

      this.serviceFactory.orbitComponentRenderService().showTimeSpentReminderWithBalance({
              playingTime: this.getCurrentSessionTime(),
              totalNetLoss: Check.isNullOrUndefined(data?.TotalNetLoss) ? 0 : data.TotalNetLoss,
              isInGame: isGameRunning
      });

      this._structuredLogger.realityCheckMessageSuccess(data, this.getCurrentSessionTime());
    }).catch(err => {

      this.serviceFactory.gameService().stopCurrentGameAutoplay();

      this.serviceFactory.orbitComponentRenderService().showTimeSpentReminderWithBalance({
              playingTime: this.getCurrentSessionTime(),
              totalNetLoss: 0,
              isInGame: isGameRunning
      });

      this._structuredLogger.realityCheckMessageError(err, this.getCurrentSessionTime().toString());
    });

  }


  _realityCheckShouldBeDisplayedInGame() {
    return this.serviceFactory
      .gameService()
      .shouldShowRealityCheckMessageWhileGameIsOpen();
  }

  openSelfExclusion(view) {
    if(!this._selfExclusionLink){
      this.logger.error("Self exclusion link for dk is missing!");
      return;
    }
    this.serviceFactory.openLinkService().openLink({
      sourceLink: this._selfExclusionLink,
      view: view
    });
  }


  openSelfTest(view) {
    if(!this._selfTestLink){
      this.logger.error("Self test link for dk is missing!");
      return;
    }
    this.serviceFactory.openLinkService().openLink({
      sourceLink: this._selfTestLink,
      view: view
    });
  }
}
